import { render, staticRenderFns } from "./PdfContractForm.vue?vue&type=template&id=8423b20e&scoped=true"
import script from "./PdfContractForm.vue?vue&type=script&lang=js"
export * from "./PdfContractForm.vue?vue&type=script&lang=js"
import style0 from "./PdfContractForm.vue?vue&type=style&index=0&id=8423b20e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8423b20e",
  null
  
)

export default component.exports